import type {FloatingAlertMode, FloatingAlertType} from 'app/core/floatingAlert/types';
import type {NamedSetState} from 'app/gemStore/devtools';
import {generateRandomString} from 'app/utils/hash/generateRandomString';

import type {FloatingAlertSlice} from './types';

export const createFloatingAlertSlice = (set: NamedSetState<FloatingAlertSlice>, get: () => Pick<FloatingAlertSlice, 'floatingAlert'>) => ({
    floatingAlert: [],
    addFloatingAlert: (type: FloatingAlertType, heading?: string, text?: string, richText?: string, mode?: FloatingAlertMode) =>
        set(
            {
                floatingAlert: [
                    ...get().floatingAlert,
                    {
                        id: generateRandomString(),
                        type,
                        mode,
                        heading,
                        text,
                        richText,
                    },
                ],
            },
            false,
            'floatingAlert/addFloatingAlert',
        ),
    removeFloatingAlert: (id: string) =>
        set(
            {
                floatingAlert: get().floatingAlert.filter((floatingAlert) => floatingAlert.id !== id),
            },
            false,
            'floatingAlert/removeFloatingAlert',
        ),
    removeAllModalFloatingAlerts: () =>
        set(
            {
                floatingAlert: get().floatingAlert.filter((floatingAlert) => floatingAlert.mode !== 'MODAL'),
            },
            false,
            'floatingAlert/removeAllModalFloatingAlerts',
        ),
});
